import { useQuery } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementAssignmentQueryKey } from '../queryKeys';
import { CustomerAgreementAssignment, CustomerAgreementCustomer } from '../types';

export function useCustomerAgreementAssignmentQuery(customer: CustomerAgreementCustomer) {
    return useQuery<CustomerAgreementAssignment>(
        [CustomerAgreementAssignmentQueryKey, customer.kind, customer.id],
        () => CustomerAgreementsApi.getAssignment(customer),
        { refetchOnWindowFocus: false }
    );
}
